// Libraries
import styled from 'styled-components'

// Components
import { Button } from 'heeds-ds'

// Assets
import anamneseCardImage from 'assets/images/evaluation-card-anamnese.png'

export const AddButton = styled(Button).attrs(() => ({
  size: 'small',
  variation: 'borderless',
}))``

export const ButtonContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 24px;
  justify-content: space-between;
  padding: 80px 0px;
  width: 100%;
  button {
    margin: 0;
  }

  @media screen and (min-width: ${({ theme }) => theme.breakpoints.desktop}px) {
    background-color: transparent;
    padding: 40px 0;
  }
`

export const CancelButton = styled(Button).attrs(() => ({
  cancel: true,
  size: 'small',
  variation: 'outlined',
}))``

export const Card = styled.div`
  align-items: center;
  background: linear-gradient(#2b2a63, #22234b99, #15192800),
    url(${anamneseCardImage}) no-repeat center;
  background-size: cover;
  border-radius: 16px;
  display: flex;
  height: 94px;
  justify-content: space-between;
  padding: 24px;
`

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  padding: 24px;
  width: 100%;
`

export const Form = styled.form``

export const NextButton = styled(Button).attrs(() => ({
  size: 'small',
  type: 'button',
}))``
